import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=fde0af4c&scoped=true&"
import script from "./transaction.vue?vue&type=script&lang=js&"
export * from "./transaction.vue?vue&type=script&lang=js&"
import style0 from "./transaction.vue?vue&type=style&index=0&id=fde0af4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde0af4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde0af4c')) {
      api.createRecord('fde0af4c', component.options)
    } else {
      api.reload('fde0af4c', component.options)
    }
    module.hot.accept("./transaction.vue?vue&type=template&id=fde0af4c&scoped=true&", function () {
      api.rerender('fde0af4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/conversion/transaction.vue"
export default component.exports